'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _draftJs = require('draft-js');

var _draftjsConstants = require('../../draftjsConstants');

/**
 * Handles a key command such as 'bold', 'italic' etc.
 */
// Lib
exports.default = function (command, _ref) {
    var getEditorState = _ref.getEditorState,
        setEditorState = _ref.setEditorState;

    var editorState = getEditorState();

    var newEditorState = _draftJs.RichUtils.handleKeyCommand(editorState, command);

    if (newEditorState) {
        setEditorState(newEditorState);
        return _draftjsConstants.HANDLER_RETURN_VALUES.handled;
    }
    return _draftjsConstants.HANDLER_RETURN_VALUES.notHandled;
};

// Constants


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/editingHelper/handleKeyCommand.js
// module id = 1730
// module chunks = 0